// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const updateSelectedContribution = data => ({
    data,
    type: actions.UPDATE_TCSM_SPA_CLAIM_SELECTED_CONTRIBUTION
});



// WEBPACK FOOTER //
// ./src/tcsm/spa-details/action-creators/selectedContribution.js